import React, {useEffect} from 'react';
import '../../App.css';
import Footer from '../Footer';
import HomeGallery from '../HomeGallery';


function PortfolioPortraits() {
    useEffect(() => {
            const timer = setTimeout(() => {
                window.scrollTo({ top: window.innerHeight * 0.75, behavior: 'smooth' });
                }, 50);
    
            return () => clearTimeout(timer);
    }, []);
        
  return (
    <>
        <h1 className='portfolio-hero'>Portfolio</h1>

        <h1 className='text'>Portraits</h1>

        <HomeGallery images={['/images/img-portraits-5.jpg','/images/img-portraits-4.jpg','/images/img-portraits-6.jpg','/images/img-portraits-8.jpg','/images/img-portraits-9.jpg','/images/img-portraits-10.jpg','/images/img-portraits-11.jpg','/images/img-portraits-12.jpg','/images/img-portraits-2.jpg','/images/img-portraits-3.jpg']} />

        <Footer />
    </>
  )
}

export default PortfolioPortraits
